import ITour from "../models/ITour";


export default class TourService {
    getTours = () => {
        var tours: ITour[] = [
            {
                id: 2,
                name: "tourDetails.tour8Days.title",
                price: 1200,
                priceWithOwnMotorcycle: 840,
                isHighlight: true,
                description: "tourDetails.tour8Days.description"
            },
            {
                id: 1,
                name: "tourDetails.tour5Days.title",
                price: 890,
                priceWithOwnMotorcycle: 640,
                isHighlight: false,
                description: "tourDetails.tour5Days.description"
            }
        ]

        return tours;
    }

}